import { useRouteContext, Link } from "@tanstack/react-router";
import { graphql, useFragment } from "react-relay";
import { Icon } from "@/components/icon";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import type { createPostButtonFragment$key } from "./__generated__/createPostButtonFragment.graphql";

type CreatePostButtonProps = {
	space?: createPostButtonFragment$key;
};

export function CreatePostButton({ space }: CreatePostButtonProps) {
	const { session, club } = useRouteContext({ from: "__root__" });
	const user = session?.user;
	const data = useFragment<createPostButtonFragment$key>(
		graphql`
	    fragment createPostButtonFragment on Space {
				slug
				postPolicy
			}
	`,
		space,
	);

	// TODO: add join modal if user can join
	if (!user) {
		return null;
	}

	const canPost = data
		? (club?.permissions.length || 0) > 0 || data?.postPolicy === "ALLOWED"
		: true;

	if (!canPost) {
		return null;
	}

	return (
		<Link to="/posts/novo" search={{ space: data?.slug }}>
			<Card className="p-6 flex flex-row items-center justify-between h-[86px]">
				<div className="flex flex-row flex-1 items-center justify-start gap-3 text-card-foreground">
					<Avatar className="size-10">
						{user.photo?.signedUrl ? (
							<AvatarImage src={user.photo?.signedUrl} />
						) : null}

						<AvatarFallback>{user.avatarFallback!}</AvatarFallback>
					</Avatar>

					<span>Criar uma nova publicação</span>
				</div>

				<Button size="icon">
					<Icon name="Plus" />
				</Button>
			</Card>
		</Link>
	);
}
